import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm } from 'react-hook-form';
import { FormProvider } from 'react-hook-form';
import CampaignBriefAccordian from './CampaignBriefAccordian';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import briefDataFix from './datafix';
import CampaignBriefHeader from './CampaignBriefHeader';
const getAttributes = (object, path, defaultValue = undefined) => {
    if (!object || !path)
        return defaultValue;
    path = path
        .replace(/\[/g, '.')
        .replace(/\]/g, '.')
        .split('.')
        .filter((i) => i);
    let index = 0;
    while (object != null && index < path.length) {
        object = object[path[index++]];
    }
    if (Array.isArray(object)) {
        return object.length ? object : undefined;
    }
    else {
        if (typeof object === 'object')
            return Object.keys(object).length ? object : undefined;
    }
    return object ? object : defaultValue;
};
const admin = process.env.REACT_APP_ADMIN || false;
const CampaignBrief = forwardRef(function CampaignBrief({ brief, apiService, enableEdit = false, onDeleteFile = () => { }, onSubmit = () => { }, isUploadRequired = false, isSubmitting = false, isSubmitted = false, onFillBriefWithAI = () => { }, }, ref) {
    var _a;
    const form = useForm({
        mode: 'onChange',
        defaultValues: briefDataFix(brief),
    });
    const { formState: { dirtyFields, touchedFields }, getValues, setValue, watch, } = form;
    const [progressValue, setProgressValue] = useState(getValues('score') || 0);
    const progressScoreArray = [
        {
            path: 'brand.email',
            score: 3,
            checked: false,
        },
        {
            path: 'brand.name',
            score: 5,
            checked: false,
        },
        {
            path: 'brand.url',
            score: 3,
            checked: false,
        },
        {
            path: 'brand.salesChannel',
            score: 2,
            checked: false,
        },
        {
            path: 'brand.category',
            score: 3,
            checked: false,
        },
        {
            path: 'brand.competitors',
            score: 5,
            checked: false,
        },
        {
            path: 'brand.productDescription',
            score: 5,
            checked: false,
        },
        {
            path: 'campaignDetails.campaignRequirement',
            score: 5,
            checked: false,
        },
        {
            path: 'campaignDetails.businessObjective',
            score: 6,
            checked: false,
        },
        {
            path: 'campaignDetails.availableAdType',
            score: 4,
            checked: false,
        },
        {
            path: 'campaignDetails.marketingObjective',
            score: 6,
            checked: false,
        },
        {
            path: 'campaignDetails.estimatedFrequency',
            score: 3,
            checked: false,
        },
        {
            path: 'campaignDetails.budget',
            score: 12,
            checked: false,
        },
        {
            path: 'campaignDetails.duration',
            score: 6,
            checked: false,
        },
        {
            path: 'targetGroup.age',
            score: 3,
            checked: false,
        },
        {
            path: 'targetGroup.gender',
            score: 3,
            checked: false,
        },
        {
            path: 'targetGroup.income',
            score: 3,
            checked: false,
        },
        {
            path: 'targetGroup.geos',
            score: 3,
            checked: false,
        },
        {
            path: 'mediaPreference.preference',
            score: 5,
            checked: false,
        },
        {
            path: 'mediaSpecificDetails',
            score: 15,
            checked: false,
        },
    ];
    useEffect(() => {
        let initialFields = [];
        let sum = 0;
        let filledForm = form.getValues();
        if (getValues('score') && !Object.keys(dirtyFields).length) {
            setProgressValue(getValues('score') || 0);
        }
        else {
            progressScoreArray.forEach((item) => {
                if (getAttributes(filledForm, item.path) &&
                    getAttributes(brief, item.path) !==
                        getAttributes(dirtyFields, item.path)) {
                    initialFields.push(item.path);
                }
            });
            initialFields.forEach((item) => {
                var _a;
                let idx = progressScoreArray === null || progressScoreArray === void 0 ? void 0 : progressScoreArray.findIndex((scr) => (scr === null || scr === void 0 ? void 0 : scr.path) === item);
                if (idx > -1) {
                    sum = sum + ((_a = progressScoreArray[idx]) === null || _a === void 0 ? void 0 : _a.score);
                }
            });
            setProgressValue(sum);
        }
    }, [watch()]);
    const [editMode, setEditMode] = useState(((_a = brief === null || brief === void 0 ? void 0 : brief.brand) === null || _a === void 0 ? void 0 : _a.name) ? false : true);
    useImperativeHandle(ref, () => ({
        submitForm() {
            setEditMode(false);
            setValue('score', progressValue);
            return form.getValues();
        },
        getValues() {
            return form.getValues();
        },
    }));
    return (_jsxs(FormProvider, Object.assign({}, form, { children: [isUploadRequired && (_jsx(CampaignBriefHeader, { brief: brief, onSubmit: (formData) => onSubmit(formData), onDeleteFile: (id) => onDeleteFile(id), isSubmitting: isSubmitting, isSubmitted: isSubmitted })), _jsx("form", { children: _jsx(CampaignBriefAccordian, { apiService: apiService, brief: briefDataFix(brief), editMode: editMode, inputProgressValue: progressValue, setEditMode: setEditMode, enableEdit: enableEdit }) })] })));
});
export default CampaignBrief;
